module.exports = __webpack_public_path__ + "static/media/DeathCard.4b846fae.jpg";